import React, { useEffect, useState, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Grid,
  TextField,
  useMediaQuery,
  InputAdornment,
  useTheme,
  Stack,
  Tooltip,
} from "@mui/material";
import {  Close } from "@mui/icons-material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Purchase_IMPURItem_Head_Detail_Update, Purchase_IMPURItem_POST, Purchase_IMPURItemB_GetRow, Purchase_Validate_ExcelItems } from "../../Server/ApiV2";
import * as XLSX from "xlsx";
import { exportToExcel, fAlertToast } from "../../Utility/Utilitys";
import { useSelector } from "react-redux";
import moment from "moment";


const ItemCreationModal=({open,handleClose,header,setHeader,loadAGetRow,disable,loadSummary,headerDetail})=> {
const theme = useTheme();
  const vRdxuserInfo = useSelector((state) => state.login.value);
const isMobileAndTablet = useMediaQuery("(max-width:900px)");
 const [filePath, setFilePath] = useState(null);
  const [detailData, setDetailData] = useState([]);

const handleExcelUpload = (event) => {
  const file = event.target.files?.[0];
  if (!file) return;
  setFilePath(file.name);
  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    const excelData = XLSX.utils.sheet_to_json(sheet, {
      raw: false, // keep strings
      rawNumbers: false,
    });
    const excelDataWithId = excelData.map((obj, index) => ({
      ...obj,
      id: index + 1,
    }));
    console.log("excel data",excelDataWithId);
    setDetailData(excelDataWithId);
    // ✅ important: allow re-uploading same file again
    event.target.value = "";
  };
  reader.readAsArrayBuffer(file);
};

const mapDetailForSave = (item) => ({
  MainGrpName: String(item.MainGrpName || ""),
  SubGrpName: String(item.SubGrpName || ""),
  GrpName: String(item.GrpName || ""),
  BrandName: String(item.BrandName || ""),
  VendorCode: String(item.VendorCode || ""),
  MainRefNo: String(item.MainRefNo || ""),
  Barcode: String(item.Barcode || ""),
  BaseUnit: String(item.BaseUnit || ""),
  Packing: String(item.Packing || ""),
  Model: String(item.Model || ""),
  HSNName: String(item.HSNName || ""),
  Name1: String(item.Name1 || ""),
  Name2: String(item.Name2 || ""),
  NameFL: String(item.NameFL || ""),
  TaxCode: String(item.TaxCode || ""),
  TaxPerc: Number(item.TaxPerc) || 0,
  Scalleable: String(item.Scalleable || ""),
  Cost: Number(item.Cost) || 0,
  RSP: Number(item.RSP) || 0,
  VATRSP: Number(item.VATRSP) || 0,
  MUnitName: String(item.MUnitName || ""),
  MUnitDesc: String(item.MUnitDesc || ""),
  MUnitPackQty: Number(item.MUnitPackQty) || 0,
  MUnitBarcode: String(item.MUnitBarcode || ""),
  MUnitCost: Number(item.MUnitCost) || 0,
  MUnitRSP: Number(item.MUnitRSP) || 0,
  MUnitVATRSP: Number(item.MUnitVATRSP) || 0,
  AGRP1: String(item.AGRP1 || ""),
  AGRP2: String(item.AGRP2 || ""),
  AGRP3: String(item.AGRP3 || ""),
  AGRP4: String(item.AGRP4 || ""),
  AGRP5: String(item.AGRP5 || ""),
  NDX: Number(item.NDX) || 0,
  Itmcd: String(item.Itmcd || ""),
  xItmcd: String(item.xItmcd || ""),
  MRP: Number(item.MRP) || 0,
  MUnitMRP: Number(item.MUNitMRP) || 0,
  HSNCode: String(item.HSNCode || ""),
  MaxDiscPerc: Number(item.MaxDiscPerc) || 0,
  LDiscPerc: Number(item.LDiscPerc) || 0,
  DiscountAmt: Number(item.DiscountAmt) || 0,
  ExciseAmount: Number(item.ExciseAmount) || 0,
  MUDisccountPerc: Number(item.MUDisccountPerc) || 0,
  MUDiscountAmt: Number(item.MUDiscountAmt) || 0,
  MUExciseAmount: Number(item.MUExciseAmount) || 0,
  SubBrand: String(item.SubBrand || ""),
  VendorDivision: String(item.VendorDivision || ""),
  VendorDivisionName: String(item.VendorDivisionName || ""),
  MOQ: Number(item.MOQ) || 0,
  SrNo: Number(item.SrNo) || 0,
  B_N_TSRRSP: Number(item.B_N_TSRRSP) || 0,
  B_CNAmt: Number(item.B_CNAmt) || 0,
  B_RBTAmt: Number(item.B_RBTAmt) || 0,
  Res1Amt: Number(item.Res1Amt) || 0,
  Res2Amt: Number(item.Res2Amt) || 0,
  Res3Amt: Number(item.Res3Amt) || 0,
  Res4Amt: Number(item.Res4Amt) || 0,
  Res5Amt: Number(item.Res5Amt) || 0,
  B_AddiCOst: Number(item.B_AddiCOst) || 0,
  Qty: Number(item.Qty) || 0,
  UnitRate: Number(item.UnitRate) || 0,
});

    const handleSave = async (isApproved = false) => {
        if(detailData?.length === 0){
          fAlertToast("WARNING", "Please upload items first.");
          return
        }
      const payload = {
        TransId: header?.TransId,
        TransDate: moment(header?.TransDate).format("MM/DD/YYYY"),
        TripId: header?.TripId,
        Narr: header?.Narr,
        UserCd: vRdxuserInfo?.UserID,
        Details: detailData?.map(mapDetailForSave),
        isApproved,
      };
      // console.log("payload",payload);    
      try {
        const resp = await Purchase_IMPURItem_Head_Detail_Update(payload);
        if (resp?.status === 200) {
          if (!isApproved) {
            fAlertToast("SUCCESS", "Saved Successfully");
            setHeader((prev) => ({
              ...prev,
              TransId: resp?.data?.ResultSet?.TransId || "",
            }));
            setFilePath("");
            await fGetrow();
          } else {
            fAlertToast("SUCCESS", "Approved Successfully!");
            await loadSummary();
          }
          await loadAGetRow();
        }
      } catch (err) {
        console.error(err);
        await fGetrow();
      }
    };

    const fGetrow = useCallback(async () => {
      try {
        if (header?.TransId && header?.TransId !== 0) {
          const resp = await Purchase_IMPURItemB_GetRow({
            TransId: header?.TransId,
          });
          if (resp?.status === 200) {
            setDetailData(resp?.data?.ResultSet || []);
          } else {
            console.error(
              "FAILED",
              resp?.response?.data?.error || resp?.message
            );
          }
        }
      } catch (err) {
        console.error(err);
      }
    }, [header?.TransId]);

    useEffect(() => {
      fGetrow();
    }, [open, header?.TransId]);

  const columns = [
    {
      field: "ItemCodeStatus",
      headerName: "",
      width: 20,
      align: "center",
      renderCell: (params) => {
        const hasItemCode = params.row.Itmcd && params.row.Itmcd.trim() !== "";

        return hasItemCode ? (
          <CheckCircleIcon style={{ color: "green" }} />
        ) : (
          <CheckCircleOutlineIcon style={{ color: "grey" }} />
        );
      },
    },
    { field: "MainGrpName", headerName: "Main Group", width: 180 },
    { field: "SubGrpName", headerName: "Sub Group", width: 150 },
    { field: "GrpName", headerName: "Group Name", width: 150 },
    { field: "BrandName", headerName: "Brand", width: 150 },
    { field: "SubBrand", headerName: "Sub Brand", width: 110 },
    { field: "VendorCode", headerName: "Vendor Code", width: 100 },
    { field: "MainRefNo", headerName: "Main Ref No", width: 90 },
    { field: "Barcode", headerName: "Barcode", width: 120 },
    { field: "BaseUnit", headerName: "Base Unit", width: 70 },
    { field: "Packing", headerName: "Packing", width: 70 },
    { field: "Model", headerName: "Model", width: 110 },
    { field: "HSNCode", headerName: "HSN Code", width: 110 },
    { field: "HSNName", headerName: "HSN Name", width: 160 },
    { field: "Name1", headerName: "Name 1", width: 180 },
    { field: "Name2", headerName: "Name 2", width: 180 },
    { field: "NameFL", headerName: "Full Name", width: 180 },
    { field: "TaxCode", headerName: "Tax Code", width: 70, align: "center" },
    {
      field: "TaxPerc",
      headerName: "Tax %",
      width: 50,
      type: "number",
      align: "center",
    },
    { field: "Scalleable", headerName: "Scalleable", width: 75, align: "left" },
    {
      field: "Cost",
      headerName: "Cost",
      width: 50,
      type: "number",
      align: "center",
    },
    {
      field: "RSP",
      headerName: "RSP",
      width: 50,
      type: "number",
      align: "center",
    },
    {
      field: "VATRSP",
      headerName: "VAT RSP",
      width: 70,
      type: "number",
      align: "center",
    },
    {
      field: "MRP",
      headerName: "MRP",
      width: 50,
      type: "number",
      align: "center",
    },
    // --- MUnit Fields ---
    { field: "MUnitName", headerName: "MUnit Name", width: 130 },
    { field: "MUnitDesc", headerName: "MUnit Desc", width: 130 },
    {
      field: "MUnitPackQty",
      headerName: "MUnit Pack Qty",
      width: 110,
      type: "number",
      align: "center",
    },
    {
      field: "MUnitBarcode",
      headerName: "MUnit Barcode",
      width: 120,
      align: "center",
      align: "center",
    },
    {
      field: "MUnitCost",
      headerName: "MUnit Cost",
      width: 95,
      type: "number",
      align: "center",
    },
    {
      field: "MUnitRSP",
      headerName: "MUnit RSP",
      width: 95,
      type: "number",
      align: "center",
    },
    {
      field: "MUnitVATRSP",
      headerName: "MUnit VAT RSP",
      width: 110,
      type: "number",
      align: "center",
    },
    {
      field: "MUnitMRP",
      headerName: "MUnit MRP",
      width: 85,
      type: "number",
      align: "center",
    },
    { field: "xItmcd", headerName: "xItem Code", width: 110 },
    { field: "Itmcd", headerName: "Item Code", width: 110 },
    // --- AGRP Fields ---
    { field: "AGRP1", headerName: "AGRP 1", width: 60, align: "center" },
    { field: "AGRP2", headerName: "AGRP 2", width: 60, align: "center" },
    { field: "AGRP3", headerName: "AGRP 3", width: 60, align: "center" },
    { field: "AGRP4", headerName: "AGRP 4", width: 60, align: "center" },
    { field: "AGRP5", headerName: "AGRP 5", width: 60, align: "center" },
    {
      field: "DisccountPerc",
      headerName: "Disc %",
      width: 60,
      type: "number",
      align: "center",
    },
    {
      field: "DiscountAmt",
      headerName: "Disc Amt",
      width: 70,
      type: "number",
      align: "center",
    },
    {
      field: "ExciseAmount",
      headerName: "Excise Amt",
      width: 90,
      type: "number",
      align: "center",
    },
    // --- MU Discounts ---
    {
      field: "MUDisccountPerc",
      headerName: "MU Disc %",
      width: 90,
      type: "number",
      align: "center",
    },
    {
      field: "MUDiscountAmt",
      headerName: "MU Disc Amt",
      width: 95,
      type: "number",
      align: "center",
    },
    {
      field: "MUExciseAmount",
      headerName: "MU Excise Amt",
      width: 105,
      type: "number",
      align: "center",
    },
    { field: "VendorDivision", headerName: "Vendor Div", width: 110 },
    {
      field: "VendorDivisionName",
      headerName: "Vendor Division Name",
      width: 180,
    },
    {
      field: "MOQ",
      headerName: "MOQ",
      width: 50,
      type: "number",
      align: "center",
    },
    {
      field: "B_N_TSRRSP",
      headerName: "TSR RSP",
      width: 90,
      type: "number",
      align: "center",
    },
    {
      field: "B_CNAmt",
      headerName: "CN Amt",
      width: 80,
      type: "number",
      align: "center",
    },
    {
      field: "B_RBTAmt",
      headerName: "RBT Amt",
      width: 80,
      type: "number",
      align: "center",
    },
    {
      field: "Res1Amt",
      headerName: "Res1 Amt",
      width: 80,
      type: "number",
      align: "center",
    },
    {
      field: "Res2Amt",
      headerName: "Res2 Amt",
      width: 80,
      type: "number",
      align: "center",
    },
    {
      field: "Res3Amt",
      headerName: "Res3 Amt",
      width: 80,
      type: "number",
      align: "center",
    },
    {
      field: "Res4Amt",
      headerName: "Res4 Amt",
      width: 80,
      type: "number",
      align: "center",
    },
    {
      field: "Res5Amt",
      headerName: "Res5 Amt",
      width: 80,
      type: "number",
      align: "center",
    },
    {
      field: "B_AddiCOst",
      headerName: "Addi Cost",
      width: 90,
      type: "number",
      align: "center",
    },
    {
      field: "Qty",
      headerName: "Qty",
      width: 50,
      type: "number",
      align: "center",
    },
    {
      field: "UnitRate",
      headerName: "Unit Rate",
      width: 90,
      type: "number",
      align: "center",
    },
  ];

  return (
    <Dialog open={open} maxWidth="xl" fullWidth fullScreen={isMobileAndTablet}>
      <DialogTitle
        sx={{
          bgcolor: "#1976d2",
          color: "white",
          py: 1,
          fontSize: "1rem",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Item Creation
        <IconButton
          onClick={() => {
            handleClose();
            setHeader({});
            setDetailData([]);
            setFilePath("");
          }}
          sx={{
            color: "#ffffff", // 👈 white icon color
            backgroundColor: "rgba(255,255,255,0.15)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.25)",
            },
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding:  "4px 16px",height:"80vh" }}>
        <Grid container spacing={2} sx={{ mb: 2, mt: 1 }}>
          <Grid item xs={3.5} sm={1.5} md={1.2} lg={0.95} xl={0.7}>
            <TextField
              label="Trans Id"
              value={header?.TransId}
              size="small"
              fullWidth
              disabled
              sx={{
                // apply primary color even when disabled
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: (theme) => `${theme.palette.primary.main} !important`,
                  fontWeight: 600,
                },
                // optional: light background for disabled field
                "& .MuiInputBase-root.Mui-disabled": {
                  backgroundColor: "#fafafa",
                  borderRadius: "6px",
                },
              }}
            />
          </Grid>
          <Grid item xs={5} sm={2} md={1.4} lg={1.2} xl={1}>
            <TextField
              label="Trans Date"
              value={moment(header?.TransDate).format("DD/MM/YYYY")}
              size="small"
              fullWidth
              disabled
              InputLabelProps={{ shrink: true }}
              sx={{
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: (theme) => `${theme.palette.primary.main} !important`,
                  fontWeight: 600,
                },
                "& .MuiInputBase-root.Mui-disabled": {
                  backgroundColor: "#fafafa",
                  borderRadius: "6px",
                },
              }}
            />
          </Grid>
          <Grid item xs={3.5} sm={1.5} md={1.2} lg={0.85} xl={0.7}>
            <TextField
              label="Trip Id"
              value={header?.TripId}
              size="small"
              fullWidth
              disabled
              sx={{
                // apply primary color even when disabled
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: (theme) => `${theme.palette.primary.main} !important`,
                  fontWeight: 600,
                },
                // optional: light background for disabled field
                "& .MuiInputBase-root.Mui-disabled": {
                  backgroundColor: "#fafafa",
                  borderRadius: "6px",
                },
              }}
            />
          </Grid>
          <Grid item xs={7} sm={4} md={3} lg={3.5}>
            <TextField
              label="Trip Name"
              value={headerDetail?.Name}
              size="small"
              fullWidth
              disabled
              sx={{
                // apply primary color even when disabled
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: (theme) => `${theme.palette.primary.main} !important`,
                  fontWeight: 600,
                },
                // optional: light background for disabled field
                "& .MuiInputBase-root.Mui-disabled": {
                  backgroundColor: "#fafafa",
                  borderRadius: "6px",
                },
              }}
            />
          </Grid>
          <Grid item xs={5} sm={3} md={2.2} lg={2} xl={2.6}>
            <TextField
              label="Buyer"
              value={headerDetail?.BuyerName}
              size="small"
              fullWidth
              disabled
              sx={{
                // apply primary color even when disabled
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: (theme) => `${theme.palette.primary.main} !important`,
                  fontWeight: 600,
                },
                // optional: light background for disabled field
                "& .MuiInputBase-root.Mui-disabled": {
                  backgroundColor: "#fafafa",
                  borderRadius: "6px",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={7} md={3} lg={3.5}>
            <TextField
              label="Narration"
              value={header?.Narr}
              onChange={(e) =>
                setHeader((prev) => ({ ...prev, Narr: e.target.value }))
              }
              size="small"
              fullWidth
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={5} md={5} lg={3.5}>
            <TextField
              size="small"
              sx={{
                mr: 2,
                "& .MuiOutlinedInput-root": {
                  paddingRight: "0px !important",
                },
                "& .MuiInputBase-input": {
                  padding: "5.5px 10px !important",
                },
              }}
              variant="outlined"
              placeholder="Excel upload"
              value={filePath}
              onClick={(e) => (e.target.value = null)}
              autoComplete="off"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <Button
                      variant="contained"
                      size="small"
                      component="label"
                      sx={{
                        textTransform: "capitalize",
                        fontWeight: 500,
                        fontSize: "12px !important",
                        padding: "0px 8px !important",
                      }}
                    >
                      Choose File
                      <input
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        hidden
                        onChange={handleExcelUpload}
                      />
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        {/* ------------ DataGrid ------------ */}
        <Box
          sx={{
            height: { xs: "53vh", sm: "65vh",md:"58vh", xl: "60vh" },
          }}
        >
          <Stack direction={"row"} justifyContent={"flex-end"}>
            <Tooltip title="Export CSV">
              <IconButton
                color="primary"
                onClick={() =>
                  exportToExcel(detailData, "Item_Creation", "Item_Creation")
                }
                size="small"
              >
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <DataGridPro
            rows={detailData}
            columns={columns}
            disableRowSelectionOnClick
            rowHeight={30}
            headerHeight={40}
            hideFooter
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          variant="contained"
          disabled={disable}
          onClick={() => handleSave(false)}
        >
          Save
        </Button>
        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={() => handleSave(true)}
          disabled={disable}
        >
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ItemCreationModal;